document.addEventListener("DOMContentLoaded", function () {

  // ------------------------------
  // CITY LABEL FORMATTER
  // ------------------------------
  function formatCityLabel(city) {
    switch (city) {
      case "delhi-ncr": return "Delhi-NCR";
      case "mumbai-pune": return "Mumbai-Pune";
      case "kolkata": return "Kolkata";
      case "bengaluru": return "Bengaluru";
      default: return city;
    }
  }

  // ------------------------------
  // ELEMENT REFERENCES
  // ------------------------------
  const popup = document.querySelector(".city-popup-main");
  const closeBtn = document.querySelector(".city-popup-content .close-city-popyp");
  const changeCityBtn = document.querySelector("a.change-city-icon");
  const submitBtn = document.querySelector(".submit-city-name");
  const citySelect = document.querySelector(".city-popup-content .select-city-wrap select.city-name");

  if (!popup || !closeBtn || !submitBtn || !citySelect) return;

  // ------------------------------
  // POPUP CONTROLS
  // ------------------------------
  function openPopup() {
    popup.classList.add("active");
  }

  function closePopup() {
    popup.classList.remove("active");
  }

  // ------------------------------
  // COOKIE HELPERS
  // ------------------------------
  function setCookie(name, value, minutes) {
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const prefix = name + "=";
    const parts = decodeURIComponent(document.cookie).split(";");

    for (let c of parts) {
      c = c.trim();
      if (c.indexOf(prefix) === 0) return c.substring(prefix.length);
    }
    return "";
  }

  // ------------------------------
  // SUBMIT CITY
  // ------------------------------
  submitBtn.addEventListener("click", function () {
    const selectedCity = citySelect.value.trim();
    if (!selectedCity) return alert("Please select a city");

    setCookie("selectedCity", selectedCity, 15);

    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: () => window.location.reload(),
      error: () => window.location.reload()
    });
  });

  // ------------------------------
  // CLOSE POPUP
  // ------------------------------
  closeBtn.addEventListener("click", closePopup);

  popup.addEventListener("click", function (e) {
    if (e.target.classList.contains("city-popup-main")) closePopup();
  });

  if (changeCityBtn) {
    changeCityBtn.addEventListener("click", function () {
      const saved = getCookie("selectedCity");
      citySelect.value = saved || "";
      openPopup();
    });
  }

  // ------------------------------
  // COOKIE CHECK (AUTO OPEN POPUP)
  // ------------------------------
  const cityName = getCookie("selectedCity");
  if (!cityName) openPopup();

  // ------------------------------
  // SET SELECTED CITY NAME IN HEADER
  // ------------------------------
  if (cityName) {
    const span = document.querySelector(".cityname-qrrow-wrpa span.cityname");
    if (span) span.textContent = formatCityLabel(cityName);
  }

  // ------------------------------
  // COLLECTION VISIBILITY (AS OLD THEME)
  // ------------------------------
  const cityCollections = {
    "delhi-ncr": [
      ".collectionAll",
      ".muffinsDelhi",
      ".bagelsDelhi",
      ".dipsDelhi",
      ".nibblesDelhi",
      ".cookiesDelhi",
      ".lavaashDelhi",
      ".dessertsDelhi"
    ],
    "mumbai-pune": [
      ".collectionAll",
      ".muffinsMumbai",
      ".bagelsMumbai",
      ".dipsMumbai",
      ".nibblesMumbai",
      ".cookiesMumbai",
      ".lavaashMumbai",
      ".dessertsMumbai"
    ],
    "kolkata": [
      ".collectionAll",
      ".muffinsKolkata",
      ".bagelsKolkata",
      ".dipsKolkata",
      ".nibblesKolkata",
      ".cookiesKolkata",
      ".lavaashKolkata",
      ".dessertsKolkata"
    ],
    "bengaluru": [
      ".collectionAll",
      ".muffinsDelhi",
      ".bagelsDelhi",
      ".dipsDelhi",
      ".nibblesDelhi",
      ".cookiesDelhi",
      ".lavaashDelhi",
      ".dessertsBangalore"
    ]
  };

  if (cityCollections[cityName]) {
    cityCollections[cityName].forEach(sel => {
      document.querySelectorAll(sel).forEach(div => {
        div.style.display = "block";
      });
    });
  }

  // ------------------------------
  // PRODUCT VISIBILITY (NEW THEME)
  // ------------------------------
  const productCards = document.querySelectorAll("product-card");

  productCards.forEach(card => {
    card.style.display = "none";
    if (cityName && card.classList.contains(cityName)) {
      card.style.display = "block";
    }
  });

  // ------------------------------
  // CART PAGE — SET CITY
  // ------------------------------
  setTimeout(() => {
    const footerCity = document.querySelector("footer.Cart__Footer input.city-selected");
    if (footerCity) footerCity.value = cityName;

    const sidebarCity = document.querySelector("#sidebar-cart input.city-selected");
    if (sidebarCity) sidebarCity.value = cityName;
  }, 3000);

});
